import { PageHeader, PageLayout } from '@/global/components';
import { FC } from 'react';
import { UnifiedProfilePageProps, UnifiedProfileSearchbar } from '../common';
import { UnifiedProfileListSourceMessage } from './UnifiedProfileListSourceMessage';
import { UnifiedProfilesTable } from './UnifiedProfilesTable';

export const UnifiedProfilesList: FC<UnifiedProfilePageProps> = ({ breadcrumbs }) => {
  return (
    <PageLayout>
      <div className='flex flex-col gap-2'>
        <PageHeader breadcrumbs={breadcrumbs} title='unifiedProfile.unifiedProfiles' subtitle='unifiedProfile.unifiedProfilesListSubtitle' />
        <UnifiedProfileListSourceMessage />
      </div>
      <div className='flex flex-col gap-6'>
        <UnifiedProfileSearchbar />
        <UnifiedProfilesTable />
      </div>
    </PageLayout>
  );
};
